<template>
  <CChartLine
    :datasets="dataSets"
    :options="options"
    :labels="labels"/>
</template>

<script>
import {CChartLine} from '@coreui/vue-chartjs'
import {getStyle, hexToRgba} from '@coreui/utils/src'

export default {
  name: 'MainChart',
  props: {
    items: Object
  },
  components: {
    CChartLine
  },
  data() {
    return {}
  },
  mounted() {
  },
  computed: {
    dataSets() {
      const brandText = getStyle('success') || '#33854f';
      const brandImage = getStyle('success') || '#f60303';
      const brandVideo = getStyle('info') || '#02b9f8';
      const brandRss = getStyle('danger') || '#023af6';
      const brandDocument = getStyle('danger') || '#fad002';

      const dataTexts = []
      const dataImages = []
      const dataVideos = []
      const dataRss = []
      const dataDocuments = []
      for (const each of Object.values(this.items)) {
        if (each.totalText != null) {
          dataTexts.push(each.totalText);
        }
        if (each.totalImage != null) {
          dataImages.push(each.totalImage);
        }
        if (each.totalVideo != null) {
          dataVideos.push(each.totalVideo);
        }
        if (each.totalRss != null) {
          dataRss.push(each.totalRss);
        }
        if (each.totalDocument != null) {
          dataDocuments.push(each.totalDocument);
        }
      }
      return [
        {
          label: 'Văn bản',
          backgroundColor: hexToRgba(brandText, 10),
          borderColor: brandText,
          pointHoverBackgroundColor: brandText,
          borderWidth: 2,
          data: dataTexts
        },
        {
          label: 'Hình ảnh',
          backgroundColor: hexToRgba(brandImage, 10),
          borderColor: brandImage,
          pointHoverBackgroundColor: brandImage,
          borderWidth: 2,
          data: dataImages
        },
        {
          label: 'Video',
          // backgroundColor: 'transparent',
          backgroundColor: hexToRgba(brandVideo, 10),
          borderColor: brandVideo,
          pointHoverBackgroundColor: brandVideo,
          borderWidth: 2,
          // borderDash: [8, 5],
          data: dataVideos
        },
        {
          label: 'RSS',
          backgroundColor: hexToRgba(brandRss, 10),
          borderColor: brandRss,
          pointHoverBackgroundColor: brandRss,
          borderWidth: 2,
          data: dataRss
        },
        {
          label: 'Tài liệu',
          backgroundColor: hexToRgba(brandDocument, 10),
          borderColor: brandDocument,
          pointHoverBackgroundColor: brandDocument,
          borderWidth: 2,
          data: dataDocuments
        }
      ]
    },
    labels() {
      return Object.keys(this.items);
    },
    options() {
      return {
        maintainAspectRatio: false,
        legend: {
          // display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: Math.ceil(250 / 5),
              // max: 250
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }
    }
  }
}
</script>
